import React from "react";
import Logo from "../components/Logo";
import RegistrationForm from "../components/RegistrationForm";

interface RegistrationPageProps {
  onSubmit: (data: {
    firstName: string;
    lastName: string;
    email: string;
    jobTitle: string;
    employerName: string;
    marketingConsent: boolean;
  }) => void;
  isLoading?: boolean;
  error?: string | null;
  testData?: any; // The completed test data
}

const RegistrationPage: React.FC<RegistrationPageProps> = ({
  onSubmit,
  isLoading = false,
  error = null,
  testData,
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 to-white">
      <div className="container mx-auto px-4 py-12 max-w-2xl">
        <header className="flex justify-center mb-8">
          <Logo size="medium" />
        </header>

        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-4">
            ¡Ya Casi Terminamos! 🎉
          </h1>
          <p className="text-lg text-gray-600 mb-4">
            ¡Has completado el Test Latino™!
          </p>
          <p className="text-gray-600">
            Por favor proporciona tu información a continuación para recibir tus resultados personalizados.
          </p>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
          <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm font-medium text-green-800">
                  ¡Test completado exitosamente! Tus resultados están listos.
                </p>
              </div>
            </div>
          </div>

          <RegistrationForm
            onSubmit={onSubmit}
            isLoading={isLoading}
            error={error}
          />
        </div>

        <div className="text-center text-sm text-gray-500">
          <p>
            📩 No olvides revisar tu carpeta de spam o junk—¡tus resultados pueden estar allí!
          </p>
        </div>
      </div>
    </div>
  );
};

export default RegistrationPage;